import { scheduleService } from "./scheduleService";
import { ScheduleOutputDTO, ScheduleFilterParams } from '@types';
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { ApiError } from '@/types/api';

// Define interface for schedule state
interface ScheduleState {
  items: ScheduleOutputDTO[];
  currentItem: ScheduleOutputDTO | null;
  loading: boolean;
  error: ApiError | null;
}

// Initial state
const initialState: ScheduleState = {
  items: [],
  currentItem: null,
  loading: false,
  error: null
};

// Create action to fetch schedules
const fetchSchedules = createAsyncThunk(
  "schedule/fetchSchedules",
  async (filters: ScheduleFilterParams, { rejectWithValue }) => {
    try {
      console.log('📡 Dispatching fetchSchedules with filters:', filters);
      const response = await scheduleService.fetchActivities(filters);
      
      if ('data' in response) {
        console.log('📡 Received schedules data:', response.data);
        return response.data;
      }
      
      console.error('📡 API Error:', response);
      return rejectWithValue(response);
    } catch (error: any) {
      console.error('📡 Exception:', error);
      return rejectWithValue(error);
    }
  }
);

// Create Redux slice
const scheduleSlice = createSlice({
  name: "schedule",
  initialState,
  reducers: {
    clearCurrentItem: (state) => {
      state.currentItem = null;
    }
  },
  extraReducers: (builder) => {
    // Fetch schedules
    builder.addCase(fetchSchedules.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    
    builder.addCase(fetchSchedules.fulfilled, (state, action) => {
      state.loading = false;
      state.items = action.payload || [];
    });
    
    builder.addCase(fetchSchedules.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload as ApiError || null;
    });
  }
});

// Export reducer and actions
export const scheduleReducer = scheduleSlice.reducer;
export const scheduleActions = scheduleSlice.actions;
export { fetchSchedules }; 